import { connect } from 'react-redux'
import { ProfileFormComponent } from './ProfileFormComponent'
import type { ProfileUserForm } from 'shared/types'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import { push } from 'connected-react-router'
import {
    deleteCreditCard,
    deleteCreditCardV2,
    deleteProfile,
    fetchProfilePageData,
    resetEmailUpdateSuccess,
    resetEmailActivateSuccess,
    resetPasswordUpdateSuccess,
    resetProfileUpdateSuccess,
    resetUpdateProfileError,
    resetDeleteKidError,
    resetDeleteProfileError,
    updateProfile
} from 'shared/store/kingdom/profile'
import { featureCodes } from 'shared/utils'

const mapStateToProps = (state: RootState) => {
    const availableFeatures = state.featuresState.available
    const shouldUpdateOptinPush = availableFeatures.includes(
        featureCodes.OPTIN_PUSH
    )
    const isActiveZendesk = state.featuresState.available.includes(
        featureCodes.ACTIVATION_ZENDESK_REDIRECTION
    )

    return {
        ...state.kingdomProfilePageState,
        shouldUpdateOptinPush,
        isActiveZendesk
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchProfileData: () => d(fetchProfilePageData()),
    updateProfile: (form: ProfileUserForm) => d(updateProfile(form)),
    deleteCreditCard: (cardYMF: string) => d(deleteCreditCard(cardYMF)),
    deleteCreditCardV2: (cardYMF: string) => d(deleteCreditCardV2(cardYMF)),
    deleteProfile: () => d(deleteProfile()),
    resetEmailSuccess: () => d(resetEmailUpdateSuccess()),
    resetEmailActivateSuccess: () => d(resetEmailActivateSuccess()),
    resetPasswordSuccess: () => d(resetPasswordUpdateSuccess()),
    resetSuccess: () => d(resetProfileUpdateSuccess()),
    resetDeleteKidError: () => d(resetDeleteKidError()),
    resetDeleteProfileError: () => d(resetDeleteProfileError()),
    resetUpdateProfileError: () => d(resetUpdateProfileError()),
    navigate: (to: string) => d(push(to))
})

const ProfileForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProfileFormComponent)

export { ProfileForm }
